import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./navbar.css";

const Navbr = () => {
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();
  const navMenuRef = useRef(null);

  useEffect(() => {
    setShowMenu(false);
  }, [location]);

  const toggleMenu = () => {
    setShowMenu((prev) => !prev);
  };

  const closeMenu = () => {
    setShowMenu(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-white/10 bg-[#0B0E13]/85 backdrop-blur-md">
      <nav
        className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6 xl:px-10"
        style={{ fontFamily: "'Inter', system-ui, sans-serif" }}
      >
        <NavLink
          to="/"
          className="flex items-center gap-2 text-lg font-bold text-[#EDEFF2] transition duration-200 hover:text-[#4CD8B8]"
          style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif" }}
        >
          <span>Stephen</span>
          <span
            className="font-mono text-xs font-normal text-[#4CD8B8]"
            style={{ fontFamily: "'JetBrains Mono', monospace" }}
          >
            //
          </span>
        </NavLink>

        <div
          ref={navMenuRef}
          className={`nav__menu ${showMenu ? "show-menu" : ""}`}
          id="nav-menu"
        >
          <ul className="flex items-center gap-1 md:gap-2">
            <li className="nav__item">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `rounded-xl px-3.5 py-2 text-xs font-semibold transition duration-200 ${
                    isActive
                      ? "bg-white/5 text-[#4CD8B8]"
                      : "text-[#929AA6] hover:bg-white/5 hover:text-[#EDEFF2]"
                  }`
                }
                onClick={closeMenu}
              >
                Home
              </NavLink>
            </li>

            <li className="nav__item">
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  `rounded-xl px-3.5 py-2 text-xs font-semibold transition duration-200 ${
                    isActive
                      ? "bg-white/5 text-[#4CD8B8]"
                      : "text-[#929AA6] hover:bg-white/5 hover:text-[#EDEFF2]"
                  }`
                }
                onClick={closeMenu}
              >
                About
              </NavLink>
            </li>

            <li className="nav__item">
              <NavLink
                to="/work"
                className={({ isActive }) =>
                  `rounded-xl px-3.5 py-2 text-xs font-semibold transition duration-200 ${
                    isActive
                      ? "bg-white/5 text-[#4CD8B8]"
                      : "text-[#929AA6] hover:bg-white/5 hover:text-[#EDEFF2]"
                  }`
                }
                onClick={closeMenu}
              >
                Work
              </NavLink>
            </li>

            <li className="nav__item">
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  `rounded-xl px-3.5 py-2 text-xs font-semibold transition duration-200 ${
                    isActive
                      ? "bg-white/5 text-[#4CD8B8]"
                      : "text-[#929AA6] hover:bg-white/5 hover:text-[#EDEFF2]"
                  }`
                }
                onClick={closeMenu}
              >
                Contact
              </NavLink>
            </li>

            <li className="nav__item ml-2">
              <NavLink
                to="/chat"
                className="inline-flex items-center gap-2 rounded-xl border border-[#4CD8B8]/30 bg-[#4CD8B8]/10 px-4 py-2 font-mono text-xs font-medium text-[#4CD8B8] shadow-sm transition duration-300 hover:border-[#4CD8B8]/60 hover:bg-[#4CD8B8]/20"
                style={{ fontFamily: "'JetBrains Mono', monospace" }}
                onClick={closeMenu}
              >
                <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#4CD8B8]" />
                Chat with my AI
              </NavLink>
            </li>
          </ul>

          <button
            type="button"
            className="nav__close text-[#929AA6] hover:text-[#EDEFF2]"
            id="nav-close"
            onClick={closeMenu}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <button
          type="button"
          className="nav__toggle text-[#EDEFF2]"
          id="nav-toggle"
          onClick={toggleMenu}
          aria-label="Open menu"
        >
          ☰
        </button>
      </nav>
    </header>
  );
};

export default Navbr;
